module.exports = __webpack_public_path__ + "static/media/video5.f6043e19.png";